import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import profileImage from "../images/alexandra.jpg";
import background from "../images/homepage-carousel.png";
import instagram from "../images/instagram-white.png";
import facebook from "../images/facebook-white.png";
import whatsapp from "../images/whatsapp-white.png";
import "../css/main.css";

const Alexandra = () => {
  return (
    <div>
      <Header />

      <div className="profile-page">
        <div className="container">
          <div className="background-image">
            <img src={background} alt="background of the profile page" />
          </div>
          <div className="box">
            <div className="image">
              <img src={profileImage} alt="profile person" />
            </div>
            <div className="content">
              <h1>Alexandra</h1>
              <h2>Psiholog</h2>
              <p>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum."
              </p>
              <p>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                exercitation ullamco laboris nisi ut aliquip ex ea commodo
                consequat. Duis aute irure dolor in reprehenderit in voluptate
                velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
                sint occaecat cupidatat non proident, sunt in culpa qui officia
                deserunt mollit anim id est laborum."
              </p>
              <div className="social-wrapper">
                <label>Pot fi contactată pe următoarele:</label>
                <div className="social">
                  <a href="/Alexandra">
                    <img src={instagram} alt="icon" />
                  </a>
                  <a href="/Alexandra">
                    <img src={facebook} alt="icon" />
                  </a>
                  <a href="/Alexandra">
                    <img src={whatsapp} alt="icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Alexandra;
